var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_363_2968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000488281,
    width: 16.0005,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_363_2968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99981 12.6666C7.81091 12.6666 7.65269 12.6026 7.52513 12.4746C7.39712 12.347 7.33312 12.1888 7.33312 11.9999V8.66659H3.99969C3.8108 8.66659 3.65235 8.60258 3.52435 8.47459C3.39679 8.34703 3.33301 8.18881 3.33301 7.99992C3.33301 7.81103 3.39679 7.65259 3.52435 7.52458C3.65235 7.39703 3.8108 7.33325 3.99969 7.33325H7.33312V3.99992C7.33312 3.81103 7.39712 3.65259 7.52513 3.52459C7.65269 3.39703 7.81091 3.33325 7.99981 3.33325C8.1887 3.33325 8.34715 3.39703 8.47516 3.52459C8.60272 3.65259 8.66649 3.81103 8.66649 3.99992V7.33325H11.9999C12.1888 7.33325 12.347 7.39703 12.4746 7.52458C12.6026 7.65259 12.6666 7.81103 12.6666 7.99992C12.6666 8.18881 12.6026 8.34703 12.4746 8.47459C12.347 8.60258 12.1888 8.66659 11.9999 8.66659H8.66649V11.9999C8.66649 12.1888 8.60272 12.347 8.47516 12.4746C8.34715 12.6026 8.1887 12.6666 7.99981 12.6666Z",
    fill: "#242424"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f95a72654aef51949a390805d3ea14cb.svg";
export { ForwardRef as ReactComponent };